import { enableAnalytics } from "@ch/api";
import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";
import { type AnalyticsCallOptions, logEvent } from "firebase/analytics";
import { usePostHog } from "posthog-js/react";
import { useCallback } from "react";
import { initializeFirebase } from "../firebase";
import type { FirebaseEventEnum, FirebaseParamMap } from "../types";

const { analytics } = initializeFirebase();

const useFirebaseAnalytics = () => {
  const user = useAppSelector((state) => state.user?.currentUser);

  const userId = user?.id;
  const userName = `${user?.firstName ?? ""} ${user?.lastName ?? ""}`;

  const posthog = usePostHog();

  const LogEvent = useCallback(
    <T extends FirebaseEventEnum>(
      event: T,
      // @ts-expect-error - TypeScript complains because T is an enum, maybe const would have been better
      params?: FirebaseParamMap[T],
      options?: AnalyticsCallOptions,
    ) => {
      if (!enableAnalytics) {
        return;
      }

      const payload = {
        ...(params ?? {}),
        platform: "web",
        userId,
        name: userName,
      };

      posthog?.capture(event, payload);

      if (!analytics) return;

      logEvent(analytics, event as string, payload, options);
    },

    [posthog, userId, userName],
  );

  return { LogEvent };
};

export default useFirebaseAnalytics;
